/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef, useState } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import styled from "styled-components";
import { DataGrid, GridColDef, GridPinnedColumnFields } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import {
    Badge,
    Button,
    IconButton,
    MenuItem,
    Menu,
    Popper,
    TextField,
    Tooltip
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid2";
import Chip from "@mui/material/Chip";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { ThreeDot } from "react-loading-indicators";
import emptyImage from "../../assets/images/image.png";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import { showToast } from "../../Components/Toast";
import { DataGridPro } from "@mui/x-data-grid-pro";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
    CompanyApi,
    getCompanyFilterMetaFieldsApi,
    getOrgFilterMetaFieldsApi,
    OrgRepoApi
} from "../Services/OrgRepo";
import { AssociatedCompanyDrawer } from "./AssociatedCompanyDrawer";
import AssociatedRFQsDrawer from "./AssociatedRFQsDrawer";
import { Link } from "react-router-dom";
import { CompanyProfileDrawer } from "./CompanyProfileDrawer";
import {
    accountManagerHead,
    getLoggedInUserID,
    generatProfilePicUrl,
    generateOrganisationLogo,
    generateCompanyLogo,
    isManagement,
    formatCurrencyValue
} from "../../Utils/Constant";
import oligasIcn from "../../assets/icons/oligas.png";
import evAutoIcn from "../../assets/icons/automotive.png";
import power from "../../assets/icons/power.png";
import industry from "../../assets/icons/industry.png";
import aerospace from "../../assets/icons/aerospace.png";
import defaultlogo from "../../assets/icons/noimg.png";
import CancelIcon from "@mui/icons-material/Cancel";

const industryIcons = {
    "Oil & Gas": oligasIcn,
    "Power & Transmission": power,
    "EV/Automotive": evAutoIcn,
    "Industrial Products": industry,
    "Aerospace & Defence": aerospace
};
const StyledTabPanel = styled(TabPanel)(({ theme }) => ({
    borderRadius: "5px",
    marginTop: "16px",
    background: "#fff"
}));

type OptionItem = { key: string; title: string };

type FilterOptionsType = {
    statusOptions?: OptionItem[];
    keyAccountManagerOptions?: OptionItem[];
    locationTypeOptions?: OptionItem[];
    turnOverOptions?: OptionItem[];
    industryTypeOptions?: OptionItem[];
    totalCorfqValueOptions?: OptionItem[];
    totalCoPoValueOptions?: OptionItem[];
};

export const OrgRepo = () => {
    const [value, setValue] = React.useState("1");
    const [searchTerm, setSearchTerm] = useState("");
    const [rows, setRows] = useState<string[]>([]);
    const [filteredRows, setFilteredRows] = useState(rows);
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const [anchorEl, setAnchorEl] = useState(null);
    //--------------------------------//
    const [selectedIndustryType, setSelectedIndustryType] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [selectedKeyAccount, setSelectedKeyAccount] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [selectedTurnOver, setSelectedTurnOver] = useState([]);
    const [selectedTotalCorfqValue, setSelectedTotalCorfqValue] = useState([]);
    const [selectedTotalCoPoValue, setSelectedTotalCoPoValue] = useState([]);
    //-------------------------//
    const [filteredSelectedIndustryType, setFilteredSelectedIndustryType] =
        useState([]);
    const [filteredSelectedStatus, setFilteredSelectedStatus] = useState([]);
    const [filteredSelectedKeyAccount, setFilteredSelectedKeyAccount] =
        useState([]);
    const [filteredSelectedLocation, setFilteredSelectedLocation] = useState(
        []
    );
    const [filteredSelectedTurnOver, setFilteredSelectedTurnOver] = useState(
        []
    );
    const [
        filteredSelectedTotalCorfqValue,
        setFilteredSelectedTotalCorfqValue
    ] = useState([]);

    const [filteredSelectedTotalCoPoValue, setFilteredSelectedTotalCoPoValue] =
        useState([]);
    //--------------------------//
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const searchInputRef = useRef<HTMLInputElement>(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [filterOptions, setFilterOptions] = useState<FilterOptionsType>({});
    const [FilteredTurnOver, setFilteredTurnOver] = useState([]);
    const [openDrawerAsRfq, setOpenDrawerAsRfq] = useState(false);
    const [companyRows, setCompanyRows] = useState([]);
    const popperRef = useRef<HTMLDivElement>(null);
    const [removeFilter, setRemoveFilter] = useState<boolean>(false);
    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 10 // Default page size
    });
    const [pinnedColumns, setPinnedColumns] =
        React.useState<GridPinnedColumnFields>({
            left: ["orgID", "organisationName", "companyID", "companyName"],
            right: ["status", "action", "keyAccoutantManager"]
        });

    const handlePinnedColumnsChange = React.useCallback(
        (updatedPinnedColumns: GridPinnedColumnFields) => {
            setPinnedColumns(updatedPinnedColumns);
        },
        []
    );
    const [isApplyFilter, setIsApplyFilter] = useState<Boolean>(false);
    const [openDrawerAsCompany, setOpenDrawerAsCompany] = useState(false);
    const handleOpenDrawerCompany = async (row: OrgRepo) => {
        setSelectedRow(row);
        setOpenDrawerAsCompany(true);
    };
    const handleCloseDrawerAsCompany = () => {
        setOpenDrawerAsCompany(false);
    };
    // Function to open drawer and set selected row data
    interface OrgRepo {
        id: number;
        orgID: string;
        organisationName: string;
        locationType: string;
        origin: string;

        associatedCompanies: string;
        associatedRFQs: string;

        organisationTurnover: string;
        keyAccountManager: string;
        totalcorfqvalue: string;
        status: string;
        action: string;
    }
    const handleOpenDrawer = async (row: OrgRepo) => {
        setSelectedRow(row);
        setOpenDrawer(true);
    };

    // Function to close drawer
    const handleCloseDrawer = () => {
        setOpenDrawer(false);
    };
    const handleCloseDrawerAsRfq = () => {
        setOpenDrawerAsRfq(false);
    };
    const handleOpenDrawerAsRfq = async (row: any) => {
        setSelectedRow(row);
        setOpenDrawerAsRfq(true);
    };

    const fetchOrgData = async () => {
        setIsLoading(true);
        try {
            const response = await OrgRepoApi();
            setIsLoading(false);
            if (response?.status) {
                let data = response?.data?.map((item: any, index: number) => ({
                    id: index + 1, // DataGrid requires a unique `id` field
                    orgID: item.orgID || `ORG${index + 1}`, // Generate an ID if missing
                    organisationName: item.organisationName,
                    keyAccountManagerID: item?.keyAccountManagerID,
                    keyAccountManagerFilePath: item?.keyAccountManagerFilePath,
                    associatedCompanies: item.associatedCompanies.join(", "), // Convert array to string
                    associatedRFQs: item.associatedRFQs.join(", "), // Convert array to string
                    locationType: item.locationType,
                    origin: item.origin,
                    organisationTurnover: item?.organisationTurnover,
                    totalcorfqvalue: item?.totalcorfqvalue,
                    totalcopovalue: item?.totalcopovalue,
                    keyAccountManager: item?.keyAccountManager,
                    status: item?.status,
                    lastUpdatedTime: item?.lastUpdatedTime,
                    ID: item?.ID,
                    orgImg: item?.orgImg,
                    KAMId: item?.KAMId
                }));
                setRows(data);
                setFilteredRows(data);
            } else {
                setRows([]);
                setFilteredRows([]);
            }
        } catch (error) {
            setRows([]);
            setFilteredRows([]);
            setIsLoading(false);
        }
    };
    const fetchCompanyData = async (params: string) => {
        setIsLoading(true);
        try {
            const response = await CompanyApi(params);
            setIsLoading(false);
            if (response?.status) {
                const data = response?.data?.map(
                    (item: any, index: number) => ({
                        id: index + 1, // Unique ID for DataGrid
                        companyID: item.companyID || `ORG${index + 1}`,
                        keyAccountManagerID: item?.keyAccoutantManagerID,
                        keyAccountManagerFilePath:
                            item?.keyAccoutantManagerProfilePath,
                        companyName: item.companyName,
                        organisationName: item.parentOrganisation,
                        industryType: item.industryType,
                        locationType: item.locationType,
                        parentOrganisation: item?.parentOrganisation,
                        address: item.address,
                        customerPocName: item.customerPocName,
                        contactNumber: item.contactNumber,
                        EmailID: item.EmailID,
                        gstApplicable: item.gstApplicable,
                        gstNumber: item.gstNumber,
                        associatedCompanyRfqs:
                            item.associatedCompanyRfqs?.join(", ") || "-",
                        totalcorfqvalue: item?.totalcorfqvalue,
                        totalcopovalue: item?.totalcopovalue,
                        keyAccoutantManager: item.keyAccoutantManager,
                        status: item?.status,
                        lastUpdatedTime: item?.lastUpdatedTime,
                        ID: item?.ID,
                        companyLogo: item?.companyLogo,
                        companyRecId: item?.ID,
                        KAMId: item?.KAMId,
                        orgID: item?.orgID
                    })
                );
                setRows(data);
                setCompanyRows(data);
            } else {
                setRows([]);

                setCompanyRows([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (value === "1") {
            fetchOrgData();
            setSelectedRow([]);
            setOpenDrawerAsRfq(false);
            setOpenDrawer(false);
            setAnchorEl(null);
            setSearchTerm("");
            makeIntialState();
            setFilterOptions({});
        } else if (value === "2") {
            fetchCompanyData(getLoggedInUserID());
            setSelectedRow([]);
            setOpenDrawerAsRfq(false);
            setOpenDrawer(false);
            setAnchorEl(null);
            setSearchTerm("");
            makeIntialState();
            setFilterOptions({});
        }
    }, [value]);

    function extractOptions(apiResponse: any[], keyName: string) {
        if (!Array.isArray(apiResponse)) return [];

        // Find the first entry that contains this key
        const section = apiResponse.find((item) => item[keyName]);
        if (!section) return [];

        const data = section[keyName];

        //direct array (like keyAccountManager)
        if (Array.isArray(data) && typeof data[0] === "string") {
            return data.map((name) => ({
                key: name,
                title: name
            }));
        }

        //choice-based object (like status, locationType, turnOver)
        if (data?.choices && Array.isArray(data.choices)) {
            return data.choices.map((choice) => ({
                key: choice.key || choice.value,
                title: choice.value || choice.key
            }));
        }

        //direct array of key-value pairs (like totalCorfqValue)
        if (Array.isArray(data) && typeof data[0] === "object") {
            // Special handling for totalCorfqValue
            if (keyName === "totalCorfqValue" || keyName === "totalCoPoValue") {
                return data.map((item) => ({
                    key: item.key,
                    value: item.value
                }));
            }
        }

        return [];
    }

    const fetchFilterMetadaFields = async () => {
        if (value === "1") {
            try {
                const filterData = await getOrgFilterMetaFieldsApi();
                if (filterData?.status) {
                    const apiResponse = filterData?.data;
                    const statusOptions = extractOptions(apiResponse, "status");
                    const keyAccountManagerOptions = extractOptions(
                        apiResponse,
                        "keyAccountManager"
                    );
                    const locationTypeOptions = extractOptions(
                        apiResponse,
                        "locationType"
                    );

                    const totalCorfqValueOptions = extractOptions(
                        apiResponse,
                        "totalCorfqValue"
                    );

                    const totalCoPoValueOptions = extractOptions(
                        apiResponse,
                        "totalCoPoValue"
                    );

                    const turnOverOptions = extractOptions(
                        apiResponse,
                        "turnOver"
                    );
                    const obj: FilterOptionsType = {
                        statusOptions,
                        keyAccountManagerOptions,
                        locationTypeOptions,
                        turnOverOptions,
                        totalCorfqValueOptions,
                        totalCoPoValueOptions
                    };

                    setFilterOptions(obj);
                }
            } catch (error) {
                console.log("Error while fetching getOrgFilterMetaFieldsApi");
            }
        } else if (value === "2") {
            try {
                const filterData = await getCompanyFilterMetaFieldsApi();
                if (filterData?.status) {
                    const apiResponse = filterData?.data;
                    const statusOptions = extractOptions(apiResponse, "status");
                    const keyAccountManagerOptions = extractOptions(
                        apiResponse,
                        "keyAccountManager"
                    );
                    const locationTypeOptions = extractOptions(
                        apiResponse,
                        "locationType"
                    );
                    const industryTypeOptions = extractOptions(
                        apiResponse,
                        "industryType"
                    );

                    const totalCorfqValueOptions = extractOptions(
                        apiResponse,
                        "totalCorfqValue"
                    );

                    const totalCoPoValueOptions = extractOptions(
                        apiResponse,
                        "totalCoPoValue"
                    );

                    const obj: FilterOptionsType = {
                        statusOptions,
                        keyAccountManagerOptions,
                        locationTypeOptions,
                        industryTypeOptions,
                        totalCorfqValueOptions,
                        totalCoPoValueOptions
                    };

                    setFilterOptions(obj);
                }
            } catch (error) {
                console.log("Error while fetching getOrgFilterMetaFieldsApi");
            }
        }
    };
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (Object.keys(filterOptions)?.length === 0) {
            fetchFilterMetadaFields();
        }
        setAnchorEl(event.currentTarget);
    };

    const filterData = (rows, filters) => {
        return rows?.filter((row) => {
            // Convert row values to lowercase arrays for comparison, handling empty values correctly
            const statusArray =
                row?.status
                    ?.toLowerCase()
                    ?.split(/\s*,\s*/)
                    ?.filter(Boolean) || [];
            const keyAccountManagerArray = row?.keyAccountManager
                ? row?.keyAccountManager
                      ?.toLowerCase()
                      ?.split(/\s*,\s*/)
                      ?.filter(Boolean) || []
                : row?.keyAccoutantManager
                      ?.toLowerCase()
                      ?.split(/\s*,\s*/)
                      ?.filter(Boolean) || [];

            const turnOverArray =
                row?.organisationTurnover
                    ?.toLowerCase()
                    ?.split(/\s*,\s*/)
                    ?.filter(Boolean) || [];
            const locationArray =
                row?.locationType
                    ?.toLowerCase()
                    ?.split(/\s*,\s*/)
                    ?.filter(Boolean) || [];
            const industryTypeArray =
                row?.industryType
                    ?.toLowerCase()
                    ?.split(/\s*,\s*/)
                    ?.filter(Boolean) || [];

            // Get filter values, ignore empty ones
            const {
                status = [],
                keyAccountManager = [],
                turnOver = [],
                locationType = [],
                industryType = [],
                totalCorfqValue = [],
                totalCoPoValue = []
            } = filters;

            // Check if each applied filter matches
            const statusMatch =
                status?.length === 0 ||
                status?.some((ind) => statusArray.includes(ind.toLowerCase()));

            const keyAccountManagerMatch =
                keyAccountManager?.length === 0 ||
                keyAccountManager.some((kam) =>
                    keyAccountManagerArray.includes(kam.toLowerCase())
                );

            const turnOverMatch =
                turnOver?.length === 0 ||
                turnOver.some((to) => turnOverArray.includes(to.toLowerCase()));

            const locationTypeMatch =
                locationType?.length === 0 ||
                locationType.some((loc) =>
                    locationArray.includes(loc.toLowerCase())
                );
            const industryTypeMatch =
                industryType?.length === 0 ||
                industryType.some((loc) =>
                    industryTypeArray.includes(loc.toLowerCase())
                );

            const num = parseFloat(row.totalcorfqvalue) || 0;

            const totalCorfqValueMatch =
                totalCorfqValue?.length === 0 ||
                totalCorfqValue.some((val) => {
                    // console.log("val", val);
                    if (val === "R1") return num >= 0 && num < 50 * 1e5;
                    if (val === "R2") return num >= 50 * 1e5 && num < 1 * 1e7;
                    if (val === "R3") return num >= 1 * 1e7 && num < 10 * 1e7;
                    if (val === "R4") return num >= 10 * 1e7;
                    return false;
                });

            const coPonum = parseInt(row.totalcopovalue) || 0;

            const totalCoPoValueMatch =
                totalCoPoValue?.length === 0 ||
                totalCoPoValue.some((val) => {
                    if (val === "R1")
                        return coPonum >= 0 && coPonum < 50 * 1e5;
                    if (val === "R2")
                        return coPonum >= 50 * 1e5 && coPonum < 1 * 1e7;
                    if (val === "R3")
                        return coPonum >= 1 * 1e7 && coPonum < 10 * 1e7;
                    if (val === "R4") return coPonum >= 10 * 1e7;
                    return false;
                });

            // **Must match ALL applied filters**
            return (
                statusMatch &&
                keyAccountManagerMatch &&
                turnOverMatch &&
                locationTypeMatch &&
                industryTypeMatch &&
                totalCorfqValueMatch &&
                totalCoPoValueMatch
            );
        });
    };

    const handleApply = async () => {
        setIsApplyFilter(true);

        let filters = {
            locationType:
                selectedLocation?.map((item) => item?.title.toLowerCase()) ||
                [],
            status:
                selectedStatus?.map((item) => item?.title.toLowerCase()) || [],
            keyAccountManager:
                selectedKeyAccount?.map((item) => item?.title.toLowerCase()) ||
                [],
            turnOver:
                selectedTurnOver?.map((item) => item?.title.toLowerCase()) ||
                [],
            industryType:
                selectedIndustryType?.map((item) =>
                    item?.title.toLowerCase()
                ) || [],
            totalCorfqValue:
                selectedTotalCorfqValue?.map((item) => item?.value) || [],
            totalCoPoValue:
                selectedTotalCoPoValue?.map((item) => item?.value) || []
        };

        const filteredResults = filterData(rows, filters);
        setFilteredSelectedIndustryType(selectedIndustryType);
        setFilteredSelectedKeyAccount(selectedKeyAccount);
        setFilteredSelectedLocation(selectedLocation);
        setFilteredSelectedStatus(selectedStatus);
        setFilteredSelectedTurnOver(selectedTurnOver);
        setFilteredSelectedTotalCorfqValue(selectedTotalCorfqValue);
        setFilteredSelectedTotalCoPoValue(selectedTotalCoPoValue);
        if (value === "1") {
            setFilteredRows(filteredResults);
            setAnchorEl(null);
        } else {
            setCompanyRows(filteredResults);
            setAnchorEl(null);
        }

        // Reset filters if all selections are empty
        if (
            selectedStatus?.length === 0 &&
            selectedKeyAccount?.length === 0 &&
            selectedTurnOver?.length === 0 &&
            selectedLocation?.length === 0 &&
            selectedIndustryType?.length === 0 &&
            selectedTotalCorfqValue?.length === 0 &&
            selectedTotalCoPoValue?.length === 0
        ) {
            setFilteredRows(rows);
            setCompanyRows(rows);
            setFilteredSelectedIndustryType(selectedIndustryType);
            setFilteredSelectedKeyAccount(selectedKeyAccount);
            setFilteredSelectedLocation(selectedLocation);
            setFilteredSelectedStatus(selectedStatus);
            setFilteredSelectedTurnOver(selectedTurnOver);
            setFilteredSelectedTotalCorfqValue(selectedTotalCorfqValue);
            setFilteredSelectedTotalCoPoValue(selectedTotalCoPoValue);
        }
    };

    useEffect(() => {
        if (filterOptions?.turnOverOptions) {
            const getLoc = selectedLocation?.map((item) => item.title);
            const data = filterOptions?.turnOverOptions?.filter((item) => {
                if (getLoc.includes("Domestic") && item.title.includes("cr")) {
                    return true;
                }
                if (
                    getLoc.includes("International") &&
                    item.title.includes("USD")
                ) {
                    return true;
                }
                if (
                    ["Domestic", "International"].every((loc) =>
                        getLoc.includes(loc)
                    )
                ) {
                    return true; // Include all items if both are selected
                }
                return false; // Default case, exclude item
            });
            setFilteredTurnOver(data);
        }
    }, [selectedLocation]);

    const makeIntialState = () => {
        setAnchorEl(null);
        setSelectedKeyAccount([]);
        setSelectedLocation([]);
        setSelectedStatus([]);
        setSelectedTurnOver([]);
        setSelectedIndustryType([]);
        setSelectedTotalCorfqValue([]);
        setSelectedTotalCoPoValue([]);
        setFilteredSelectedIndustryType([]);
        setFilteredSelectedKeyAccount([]);
        setFilteredSelectedLocation([]);
        setFilteredSelectedStatus([]);
        setFilteredSelectedTurnOver([]);
        setFilteredSelectedTotalCorfqValue([]);
        setFilteredSelectedTotalCoPoValue([]);
        setFilteredRows(rows);
        setIsApplyFilter(false);
        setCompanyRows(rows);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setSelectedIndustryType(filteredSelectedIndustryType);
        setSelectedKeyAccount(filteredSelectedKeyAccount);
        setSelectedLocation(filteredSelectedLocation);
        setSelectedStatus(filteredSelectedStatus);
        setSelectedTurnOver(filteredSelectedTurnOver);
        setSelectedTotalCorfqValue(filteredSelectedTotalCorfqValue);
        setSelectedTotalCoPoValue(filteredSelectedTotalCoPoValue);
    };
    const handleClearAll = () => {
        setSelectedKeyAccount([]);
        setSelectedLocation([]);
        setSelectedStatus([]);
        setSelectedTurnOver([]);
        setSelectedIndustryType([]);
        setSelectedTotalCorfqValue([]);
        setFilteredSelectedTotalCoPoValue([]);
    };
    const handleClearAllChip = () => {
        makeIntialState();
    };
    /**Filter functionality end  here */

    // Handle tab change
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
        setSearchTerm(""); // Clear search when switching tabs
        setSelectedRows([]);
    };

    // Handle search input change
    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (value === "1") {
            const search = event.target.value;
            setSearchTerm(search);

            if (search.length >= 3) {
                const filtered = rows?.filter((row) =>
                    ["orgID", "organisationName"].some(
                        (key) =>
                            typeof row[key] === "string" &&
                            row[key]
                                .toLowerCase()
                                .includes(search.toLowerCase())
                    )
                );
                setFilteredRows(filtered);
            } else {
                setFilteredRows(rows); // Reset when search is less than 3 characters
            }
        } else if (value === "2") {
            const search = event.target.value;
            setSearchTerm(search);

            if (search.length >= 3) {
                const filtered = rows?.filter((row) =>
                    ["companyID", "companyName"].some(
                        (key) =>
                            typeof row[key] === "string" &&
                            row[key]
                                .toLowerCase()
                                .includes(search.toLowerCase())
                    )
                );
                setCompanyRows(filtered);
            } else {
                setCompanyRows(rows); // Reset when search is less than 3 characters
            }
        }
    };

    const handleSelectionChange = (selection: any) => {
        setSelectedRows(selection);
    };

    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [searchTerm]);

    const AssociateCompany = ({
        value,
        onChipClick
    }: {
        value: string | string[];
        onChipClick?: (type: string) => void;
    }) => {
        const [expanded, setExpanded] = useState(false);
        const types = Array.isArray(value) ? value : value?.split(", ") || [];

        const displayedTypes = expanded ? types : types.slice(0, 1);
        const remainingCount = types.length - 1;

        const handleChipClick = (type: string) => {
            if (!expanded) setExpanded(true); // expand on first click
            onChipClick?.(type); // trigger drawer or any external action
        };
        return (
            <Box
                sx={{
                    gap: 0.5,
                    alignItems: "center",
                    height: "100%",
                    margin: "5px 0 3px"
                }}
            >
                {displayedTypes?.map((type, idx) =>
                    type ? (
                        <Chip
                            key={idx}
                            label={type}
                            size="small"
                            sx={{
                                margin: "5px 0px 0px 5px",
                                backgroundColor:
                                    type === "-" ? "transparent" : undefined
                            }}
                            onClick={() => handleChipClick(type)}
                        />
                    ) : (
                        "-"
                    )
                )}
                {!expanded && remainingCount > 0 && (
                    <Chip
                        label={`+${remainingCount}`}
                        size="small"
                        sx={{ cursor: "pointer", margin: "5px 0px 0px 5px" }}
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setExpanded(true);
                        }}
                    />
                )}
                {expanded && (
                    <IconButton
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setExpanded(false);
                        }}
                        sx={{ margin: "5px 0px 0px 5px" }}
                    >
                        <CancelIcon fontSize="small" />
                    </IconButton>
                )}
            </Box>
        );
    };
    const columns: GridColDef[] = [
        {
            field: "orgID",
            headerName: "Org ID",
            width: 100,
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <Link
                        to="/layout/OrgProfilePage"
                        target="_blank"
                        state={{ orgId: params.row.ID }}
                        onClick={() => {
                            localStorage.setItem(
                                "OrgProfilePage",
                                JSON.stringify({
                                    orgId: params.row.ID
                                })
                            );
                        }}
                        style={{ textDecoration: "none" }}
                    >
                        {params?.value}
                    </Link>
                );
            }
        },
        {
            field: "organisationName",
            headerName: "Organisation Name",
            minWidth: 200,
            disableColumnMenu: true,
            renderCell: (params) => {
                const name = params.value || "";
                const truncatedName = name;
                const uniqueId = params.row.unique_ID; // Get the Unique ID
                const logoUrl = params.row.orgImg
                    ? generateOrganisationLogo(params.row.ID, params.row.orgImg)
                    : defaultlogo;
                const payload = { orgId: params.row.ID };
                return (
                    <Link
                        to="/layout/OrgProfilePage"
                        target="_blank"
                        state={{ payload }}
                        onClick={() => {
                            localStorage.setItem(
                                "OrgProfilePage",
                                JSON.stringify(payload)
                            );
                        }}
                        style={{ textDecoration: "none" }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                height: "100%",
                                cursor: "pointer"
                            }}
                        >
                            {logoUrl && (
                                <img
                                    src={logoUrl}
                                    alt={name}
                                    width={28}
                                    height={28}
                                    style={{
                                        borderRadius: "50%",
                                        border: "1px solid #d8d8d8"
                                    }}
                                />
                            )}
                            <Typography variant="body2" className="hoverClr">
                                {truncatedName}
                            </Typography>
                        </Box>
                    </Link>
                );
            }
        },

        {
            field: "locationType",
            headerName: "Presence",
            width: 150,
            disableColumnMenu: true,
            renderCell: (params) => {
                if (!params.value) {
                    return "-";
                }
                const chipColor =
                    params.value === "Domestic" ? "primary" : "secondary";
                return (
                    <Chip
                        label={params.value}
                        color={chipColor}
                        variant="outlined"
                        size="small"
                    />
                );
            }
        },

        {
            field: "origin",
            headerName: "Origin",
            width: 100,
            disableColumnMenu: true
        },

        {
            field: "associatedCompanies",
            headerName: "Associated Companies",
            width: 200,
            disableColumnMenu: true,
            renderCell: (params) => (
                <div
                    onClick={() => handleOpenDrawer(params.row)}
                    style={{ cursor: "pointer" }}
                >
                    <AssociateCompany value={params.value || "-"} />
                </div>
            )
        },

        {
            field: "associatedRFQs",
            headerName: "Associated CORFQs",
            width: 200,
            disableColumnMenu: true,
            renderCell: (params) => (
                <div
                    onClick={() => handleOpenDrawerAsRfq(params.row)}
                    style={{ cursor: "pointer" }}
                >
                    <AssociateCompany value={params.value || "-"} />
                </div>
            )
        },

        {
            field: "organisationTurnover",
            headerName: "Organisation Turnover",
            width: 250,
            disableColumnMenu: true
        },
        {
            field: "totalcorfqvalue",
            headerName: "Total CORFQ Value",
            width: 250,
            disableColumnMenu: true,
            renderCell: (params) => {
                const value = params?.value;
                const formattedValue = formatCurrencyValue(value);
                return (
                    <Typography variant="body2">₹ {formattedValue}</Typography>
                );
            }
        },
        {
            field: "totalcopovalue",
            headerName: "Total COPO Value",
            width: 250,
            disableColumnMenu: true,
            renderCell: (params) => {
                const value = params?.value;
                const formattedValue = formatCurrencyValue(value);
                return (
                    <Typography variant="body2">₹ {formattedValue}</Typography>
                );
            }
        }
    ];

    const partnerMessages: Record<string, string> = {
        "1": "No Organisation Captured Yet",
        "2": "No Company Captured Yet"
    };

    const columnsCompany: GridColDef[] = [
        {
            field: "companyID",
            headerName: "Company ID",
            width: 150,
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <div
                        onClick={() => handleOpenDrawerCompany(params.row)}
                        style={{ cursor: "pointer" }}
                        className="hoverClr"
                    >
                        {params?.value}
                    </div>
                );
            }
        },
        {
            field: "companyName",
            headerName: "Company Name",
            minWidth: 200,
            disableColumnMenu: true,
            renderCell: (params) => {
                const name = params.value || "";
                const truncatedName = name;
                const logoUrl = params.row.companyLogo
                    ? generateCompanyLogo(params.row.ID, params.row.companyLogo)
                    : defaultlogo;
                return (
                    <div
                        onClick={() => handleOpenDrawerCompany(params.row)}
                        style={{ cursor: "pointer" }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                // overflow: "hidden",
                                // textOverflow: "ellipsis",
                                // whiteSpace: "nowrap",
                                height: "100%",
                                cursor: "pointer"
                            }}
                        >
                            {logoUrl && (
                                <img
                                    src={logoUrl}
                                    alt={name}
                                    width={28}
                                    height={28}
                                    style={{
                                        borderRadius: "50%",
                                        border: "1px solid #d8d8d8"
                                    }}
                                />
                            )}
                            <Typography variant="body2" className="hoverClr">
                                {truncatedName}
                            </Typography>
                        </Box>
                    </div>
                );
            }
        },

        {
            field: "industryType",
            headerName: "Industry Type",
            width: 200,
            disableColumnMenu: true,
            renderCell: (params) => {
                const industry = params.value; // Get industry type
                const iconSrc = industryIcons[industry]; // Get icon based on industry type
                return (
                    <Chip
                        sx={{
                            paddingLeft: "0px",
                            "& .MuiChip-label": {
                                paddingLeft: "0px"
                            }
                        }}
                        size="small"
                        label={industry}
                        variant="filled"
                        icon={
                            iconSrc ? (
                                <img
                                    src={iconSrc}
                                    alt={industry}
                                    width="14px"
                                    height="14px"
                                    style={{ marginRight: "5px" }}
                                />
                            ) : undefined
                        }
                    />
                );
            }
        },

        {
            field: "locationType",
            headerName: "Presence",
            width: 200,
            disableColumnMenu: true,
            renderCell: (params) => {
                if (!params.value) {
                    return "-";
                }
                const chipColor =
                    params.value === "Domestic" ? "primary" : "secondary";
                return (
                    <Chip
                        label={params.value}
                        color={chipColor}
                        variant="outlined"
                        size="small"
                    />
                );
            }
        },

        {
            field: "parentOrganisation",
            headerName: "Parent Organisation",
            width: 200,
            disableColumnMenu: true,
            renderCell: (params) => (
                <div
                    onClick={() => handleOpenDrawer(params.row)}
                    style={{ cursor: "pointer" }}
                >
                    <AssociateCompany value={params.value || "-"} />
                </div>
            )
        },

        // {
        //     field: "address",
        //     headerName: "Address",
        //     width: 250,
        //     disableColumnMenu: true
        // },
        // {
        //     field: "customerPocName",
        //     headerName: "Company POC Name",
        //     width: 200,
        //     disableColumnMenu: true
        // },
        // {
        //     field: "contactNumber",
        //     headerName: "Contact Number",
        //     width: 200,
        //     renderCell: (params) => {
        //         return (
        //             <Typography variant="body2">
        //                 {params.value || "-"}
        //             </Typography>
        //         );
        //     }
        // },
        // {
        //     field: "EmailID",
        //     headerName: "Email ID",
        //     width: 250
        // },
        // {
        //     field: "gstApplicable",
        //     headerName: "GST Applicable",
        //     width: 150
        // },
        // {
        //     field: "gstNumber",
        //     headerName: "GST Number",
        //     width: 200,
        //     renderCell: (params) => {
        //         return (
        //             <Typography variant="body2">
        //                 {params.value || "-"}
        //             </Typography>
        //         );
        //     }
        // },

        {
            field: "associatedCompanyRfqs",
            headerName: "Associated CORFQs",
            width: 200,
            renderCell: (params) => (
                <div
                    onClick={() => handleOpenDrawerAsRfq(params.row)}
                    style={{ cursor: "pointer" }}
                >
                    <AssociateCompany value={params.value || "-"} />
                </div>
            )
        },

        {
            field: "totalcorfqvalue",
            headerName: "Total CORFQ Value",
            width: 250,
            disableColumnMenu: true,
            renderCell: (params) => {
                const value = params?.value;
                const formattedValue = formatCurrencyValue(value);
                return (
                    <Typography variant="body2">₹ {formattedValue}</Typography>
                );
            }
        },

        {
            field: "totalcopovalue",
            headerName: "Total COPO Value",
            width: 250,
            disableColumnMenu: true,
            renderCell: (params) => {
                const value = params?.value;
                const formattedValue = formatCurrencyValue(value);
                return (
                    <Typography variant="body2">₹ {formattedValue}</Typography>
                );
            }
        },

        ...(accountManagerHead() || isManagement()
            ? [
                  {
                      field: "keyAccoutantManager",
                      headerName: "Key Accountant Manager",
                      width: 200,
                      cellClassName: () => "first-pinned-right",
                      headerClassName: "first-pinned-right",
                      renderCell: (params) => {
                          const name = params.value || "";
                          return (
                              <Grid
                                  container
                                  spacing={2}
                                  alignItems="center"
                                  width="100%"
                              >
                                  <Grid size={{ xs: 2, md: 2 }}>
                                      <img
                                          src={
                                              generatProfilePicUrl(
                                                  params.row
                                                      .keyAccountManagerID,
                                                  params.row
                                                      .keyAccountManagerFilePath,
                                                  "Profile_Picture"
                                              ) || ""
                                          }
                                          alt="KAM"
                                          width={24}
                                          height={24}
                                          style={{
                                              marginRight: "5px",
                                              borderRadius: "50%"
                                          }}
                                      />
                                  </Grid>
                                  <Grid size={{ xs: 10, md: 10 }}>
                                      <Typography variant="body2" className="">
                                          {name}
                                      </Typography>
                                  </Grid>
                              </Grid>
                          );
                      }
                  }
              ]
            : [])
    ];

    const handleRemoveFilter = (category, item) => {
        if (removeFilter == true) {
            setRemoveFilter(false);
        } else {
            setRemoveFilter(true);
        }
        switch (category) {
            case "industry":
                setSelectedIndustryType((prev) =>
                    prev?.filter((i) => i.title !== item.title)
                );
                break;
            case "status":
                setSelectedStatus((prev) =>
                    prev?.filter((i) => i.title !== item.title)
                );
                break;
            case "keyAccountManager":
                setSelectedKeyAccount((prev) =>
                    prev?.filter((i) => i.title !== item.title)
                );
                break;
            case "turnOver":
                setSelectedTurnOver((prev) =>
                    prev?.filter((i) => i.title !== item.title)
                );
                break;
            case "location":
                setSelectedLocation((prev) =>
                    prev?.filter((i) => i.title !== item.title)
                );
                break;
            case "totalCorfqValue":
                setSelectedTotalCorfqValue((prev) =>
                    prev?.filter((i) => i.key !== item.key)
                );
                break;
            case "totalCoPoValue":
                setSelectedTotalCoPoValue((prev) =>
                    prev?.filter((i) => i.key !== item.key)
                );
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        handleApply();
        if (
            selectedIndustryType?.length === 0 &&
            selectedLocation?.length == 0 &&
            selectedKeyAccount?.length == 0 &&
            selectedStatus?.length == 0 &&
            selectedTurnOver?.length == 0 &&
            selectedTotalCorfqValue?.length == 0 &&
            selectedTotalCoPoValue?.length == 0
        ) {
            setIsApplyFilter(false);
        }
    }, [removeFilter]);
    return (
        <>
            <Breadcrumbs aria-label="breadcrumb">
                <Typography key="account" sx={{ fontSize: "14px" }}>
                    <Link
                        to="/layout/Dashboard"
                        style={{
                            color: "#0070BA",
                            fontSize: "14px",
                            textDecoration: "none"
                        }}
                    >
                        Home
                    </Link>
                </Typography>
                <Typography sx={{ fontSize: "14px" }}>
                    Organisations Repository
                </Typography>
            </Breadcrumbs>

            <Typography variant="h5" mb={1}>
                Organisations Repository
            </Typography>

            <Box sx={{ width: "100%", typography: "body1" }}>
                <TabContext value={value}>
                    <Box>
                        <TabList
                            onChange={handleChange}
                            aria-label="lab API tabs example"
                        >
                            <Tab label="ORGANISATION" value="1" />
                            <Tab label="COMPANY" value="2" />
                        </TabList>
                    </Box>

                    <StyledTabPanel value="1">
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, md: 6 }}>
                                {rows?.length > 1 && (
                                    <Grid container spacing={2} mb={1}>
                                        {/* Search Section */}
                                        <Grid size={{ xs: 12, md: 7 }}>
                                            <TextField
                                                label="Search by Org ID & Org Name"
                                                size="small"
                                                variant="outlined"
                                                fullWidth
                                                inputRef={searchInputRef}
                                                value={searchTerm}
                                                onChange={handleSearch}
                                            />
                                        </Grid>
                                        {/* Filter section */}
                                        <Grid
                                            size={{ xs: 12, md: 5 }}
                                            sx={{
                                                color: "grey",
                                                display: "flex",
                                                alignItems: "center"
                                            }}
                                        >
                                            <Box>
                                                <IconButton
                                                    onClick={handleClick}
                                                >
                                                    <Badge
                                                        badgeContent={
                                                            filteredSelectedIndustryType?.length +
                                                            filteredSelectedStatus?.length +
                                                            filteredSelectedKeyAccount?.length +
                                                            filteredSelectedLocation?.length +
                                                            filteredSelectedTurnOver?.length +
                                                            filteredSelectedTotalCorfqValue?.length +
                                                            filteredSelectedTotalCoPoValue.length
                                                        }
                                                        color="primary"
                                                    >
                                                        <FilterAltOutlinedIcon />
                                                    </Badge>
                                                </IconButton>
                                                <Popper
                                                    open={Boolean(anchorEl)}
                                                    anchorEl={anchorEl}
                                                    placement="bottom-start"
                                                    sx={{ zIndex: 13 }}
                                                >
                                                    <Paper
                                                        ref={popperRef}
                                                        sx={{
                                                            p: 2,
                                                            width: 350,
                                                            boxShadow: 3,
                                                            borderRadius: 2
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                fontWeight:
                                                                    "bold",
                                                                mb: 2,
                                                                display: "flex",
                                                                justifyContent:
                                                                    "space-between"
                                                            }}
                                                        >
                                                            Filter{" "}
                                                            <Button
                                                                size="small"
                                                                variant="outlined"
                                                                onClick={
                                                                    handleClearAll
                                                                }
                                                            >
                                                                CLEAR ALL
                                                            </Button>
                                                        </Box>

                                                        <Box sx={{ mb: 2 }}>
                                                            <Autocomplete
                                                                multiple
                                                                size="small"
                                                                sx={{
                                                                    marginBottom:
                                                                        "15px"
                                                                }}
                                                                limitTags={2}
                                                                id="multiple-limit-tags"
                                                                getOptionLabel={(
                                                                    option
                                                                ) =>
                                                                    option?.key ||
                                                                    option?.value ||
                                                                    ""
                                                                }
                                                                value={
                                                                    selectedLocation
                                                                }
                                                                onChange={(
                                                                    event,
                                                                    newValue
                                                                ) =>
                                                                    setSelectedLocation(
                                                                        newValue ||
                                                                            []
                                                                    )
                                                                }
                                                                isOptionEqualToValue={(
                                                                    option,
                                                                    value
                                                                ) =>
                                                                    option.title ===
                                                                    value?.title
                                                                }
                                                                options={[
                                                                    ...(filterOptions?.locationTypeOptions ||
                                                                        [])
                                                                ]?.sort(
                                                                    (a, b) =>
                                                                        a?.title?.localeCompare(
                                                                            b?.title
                                                                        )
                                                                )}
                                                                renderInput={(
                                                                    params
                                                                ) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Presence"
                                                                        placeholder="Presence"
                                                                    />
                                                                )}
                                                            />

                                                            <Autocomplete
                                                                multiple
                                                                size="small"
                                                                sx={{
                                                                    marginBottom:
                                                                        "15px"
                                                                }}
                                                                limitTags={2}
                                                                id="multiple-limit-tags"
                                                                options={[
                                                                    ...FilteredTurnOver
                                                                ]?.sort(
                                                                    (a, b) =>
                                                                        a.title.localeCompare(
                                                                            b.title
                                                                        )
                                                                )}
                                                                getOptionLabel={(
                                                                    option
                                                                ) =>
                                                                    option?.title ||
                                                                    ""
                                                                }
                                                                value={
                                                                    selectedTurnOver
                                                                }
                                                                onChange={(
                                                                    event,
                                                                    newValue
                                                                ) =>
                                                                    setSelectedTurnOver(
                                                                        newValue ||
                                                                            []
                                                                    )
                                                                }
                                                                isOptionEqualToValue={(
                                                                    option,
                                                                    value
                                                                ) =>
                                                                    option.title ===
                                                                    value?.title
                                                                }
                                                                disabled={
                                                                    selectedLocation.length ===
                                                                    0
                                                                }
                                                                renderInput={(
                                                                    params
                                                                ) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Turnover"
                                                                        placeholder="Select Turnover"
                                                                    />
                                                                )}
                                                            />

                                                            <Autocomplete
                                                                multiple
                                                                size="small"
                                                                sx={{
                                                                    marginBottom:
                                                                        "15px"
                                                                }}
                                                                limitTags={2}
                                                                id="totalCorfqValue"
                                                                options={[
                                                                    ...(filterOptions?.totalCorfqValueOptions ||
                                                                        [])
                                                                ]}
                                                                getOptionLabel={(
                                                                    option
                                                                ) =>
                                                                    option?.key ||
                                                                    ""
                                                                }
                                                                value={
                                                                    selectedTotalCorfqValue
                                                                }
                                                                onChange={(
                                                                    event,
                                                                    newValue
                                                                ) =>
                                                                    setSelectedTotalCorfqValue(
                                                                        newValue ||
                                                                            []
                                                                    )
                                                                }
                                                                renderInput={(
                                                                    params
                                                                ) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Total CORFQ Value"
                                                                        placeholder="Select Total CORFQ Value"
                                                                    />
                                                                )}
                                                            />

                                                            <Autocomplete
                                                                multiple
                                                                size="small"
                                                                sx={{
                                                                    marginBottom:
                                                                        "15px"
                                                                }}
                                                                limitTags={2}
                                                                id="totalCoPoValue"
                                                                options={[
                                                                    ...(filterOptions?.totalCoPoValueOptions ||
                                                                        [])
                                                                ]}
                                                                getOptionLabel={(
                                                                    option
                                                                ) =>
                                                                    option?.key ||
                                                                    ""
                                                                }
                                                                value={
                                                                    selectedTotalCoPoValue
                                                                }
                                                                onChange={(
                                                                    event,
                                                                    newValue
                                                                ) =>
                                                                    setSelectedTotalCoPoValue(
                                                                        newValue ||
                                                                            []
                                                                    )
                                                                }
                                                                renderInput={(
                                                                    params
                                                                ) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Total COPO Value"
                                                                        placeholder="Select Total COPO Value"
                                                                    />
                                                                )}
                                                            />
                                                        </Box>

                                                        {/* Apply / Cancel Buttons */}
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                justifyContent:
                                                                    "space-between",
                                                                mt: 2
                                                            }}
                                                        >
                                                            <Button
                                                                onClick={
                                                                    handleClose
                                                                }
                                                                color="error"
                                                            >
                                                                CANCEL
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={
                                                                    handleApply
                                                                }
                                                            >
                                                                APPLY
                                                            </Button>
                                                        </Box>
                                                    </Paper>
                                                </Popper>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                        <Grid size={{ xs: 12, md: 12 }}>
                            {/* Selected Filters as Chips */}
                            {isApplyFilter == true && (
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: 1,
                                        marginBottom: "10px"
                                    }}
                                    mb={2}
                                >
                                    {filteredSelectedLocation?.map(
                                        (item, index) => (
                                            <Chip
                                                key={`location-${index}`}
                                                label={item?.title}
                                                onDelete={() =>
                                                    handleRemoveFilter(
                                                        "location",
                                                        item
                                                    )
                                                }
                                                size="small"
                                            />
                                        )
                                    )}
                                    {filteredSelectedStatus?.map(
                                        (item, index) => (
                                            <Chip
                                                key={`status-${index}`}
                                                label={item.title}
                                                onDelete={() =>
                                                    handleRemoveFilter(
                                                        "status",
                                                        item
                                                    )
                                                }
                                                size="small"
                                            />
                                        )
                                    )}
                                    {filteredSelectedKeyAccount?.map(
                                        (item, index) => (
                                            <Chip
                                                key={`keyAccountManager-${index}`}
                                                label={item?.title}
                                                onDelete={() =>
                                                    handleRemoveFilter(
                                                        "keyAccountManager",
                                                        item
                                                    )
                                                }
                                                size="small"
                                            />
                                        )
                                    )}
                                    {filteredSelectedTurnOver?.map(
                                        (item, index) => (
                                            <Chip
                                                key={`turnOver-${index}`}
                                                label={item?.title}
                                                onDelete={() =>
                                                    handleRemoveFilter(
                                                        "turnOver",
                                                        item
                                                    )
                                                }
                                                size="small"
                                            />
                                        )
                                    )}

                                    {filteredSelectedTotalCorfqValue?.map(
                                        (item, index) => (
                                            <Chip
                                                key={`totalCorfqValue-${index}`}
                                                label={item?.key}
                                                onDelete={() =>
                                                    handleRemoveFilter(
                                                        "totalCorfqValue",
                                                        item
                                                    )
                                                }
                                                size="small"
                                            />
                                        )
                                    )}

                                    {filteredSelectedTotalCoPoValue?.map(
                                        (item, index) => (
                                            <Chip
                                                key={`totalCoPoValue-${index}`}
                                                label={item?.key}
                                                onDelete={() =>
                                                    handleRemoveFilter(
                                                        "totalCoPoValue",
                                                        item
                                                    )
                                                }
                                                size="small"
                                            />
                                        )
                                    )}

                                    {/* Clear All Button - Show only when filters exist */}
                                    {filteredSelectedLocation?.length +
                                        filteredSelectedIndustryType?.length +
                                        filteredSelectedKeyAccount?.length +
                                        filteredSelectedStatus?.length +
                                        filteredSelectedTurnOver?.length +
                                        filteredSelectedTotalCorfqValue?.length +
                                        filteredSelectedTotalCoPoValue?.length >
                                        0 && (
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            onClick={handleClearAllChip}
                                            sx={{
                                                fontSize: ".75rem !important",
                                                lineHeight: "1",
                                                borderRadius: "30px"
                                            }}
                                        >
                                            CLEAR ALL
                                        </Button>
                                    )}
                                </Box>
                            )}
                        </Grid>
                        <Paper
                            sx={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height:
                                    filteredRows?.length > 4
                                        ? "61vh"
                                        : filteredRows?.length < 4
                                          ? "auto"
                                          : "61vh"
                            }}
                        >
                            {!isLoading ? (
                                filteredRows?.length > 0 ? (
                                    <DataGridPro
                                        rows={filteredRows}
                                        pinnedColumns={pinnedColumns}
                                        getRowHeight={() => "auto"}
                                        onPinnedColumnsChange={
                                            handlePinnedColumnsChange
                                        }
                                        columns={columns}
                                        pagination={filteredRows?.length > 10}
                                        paginationModel={paginationModel}
                                        onPaginationModelChange={
                                            setPaginationModel
                                        }
                                        pageSizeOptions={[10, 20]}
                                        rowSelectionModel={selectedRows}
                                        onRowSelectionModelChange={
                                            handleSelectionChange
                                        }
                                        disableRowSelectionOnClick={true}
                                        sx={{
                                            width: "100%",
                                            "& .MuiDataGrid-columnHeaderTitleContainer":
                                                {
                                                    "& .MuiDataGrid-sortIcon": {
                                                        opacity: "1 !important",
                                                        visibility:
                                                            "visible !important"
                                                    }
                                                },
                                            "& .MuiDataGrid-cell": {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            "& .MuiDataGrid-scrollbarFiller--pinnedRight":
                                                {
                                                    backgroundColor:
                                                        "#F4F4F4!important"
                                                }
                                        }}
                                    />
                                ) : (
                                    <>
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                gap: "8px",
                                                padding: "20px"
                                            }}
                                        >
                                            {(searchTerm &&
                                                filteredRows.length == 0) ||
                                            (isApplyFilter &&
                                                filteredRows.length == 0) ? (
                                                "No Options available"
                                            ) : (
                                                <>
                                                    <img
                                                        src={emptyImage}
                                                        alt="Empty"
                                                        width={"300px"}
                                                    />
                                                    <b
                                                        style={{
                                                            color: "#0009"
                                                        }}
                                                    >
                                                        {partnerMessages[
                                                            value
                                                        ] || "Unknown Status"}
                                                    </b>
                                                </>
                                            )}
                                        </div>
                                    </>
                                )
                            ) : (
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="50vh"
                                >
                                    <ThreeDot
                                        color="#1976d2"
                                        size="medium"
                                        text=""
                                        textColor=""
                                    />
                                </Box>
                            )}
                        </Paper>
                    </StyledTabPanel>

                    <StyledTabPanel value="2">
                        <Grid container spacing={2} mb={1}>
                            <Grid size={{ xs: 12, md: 6 }}>
                                {rows?.length > 1 && (
                                    <Grid container spacing={2}>
                                        {/* Search Section */}
                                        <Grid size={{ xs: 12, md: 7 }}>
                                            <TextField
                                                label="Search by Company ID & Company Name"
                                                size="small"
                                                variant="outlined"
                                                fullWidth
                                                inputRef={searchInputRef}
                                                value={searchTerm}
                                                onChange={handleSearch}
                                            />
                                        </Grid>
                                        {/* Filter section */}
                                        <Grid
                                            size={{ xs: 12, md: 5 }}
                                            sx={{
                                                color: "grey",
                                                display: "flex",
                                                alignItems: "center"
                                            }}
                                        >
                                            <Box>
                                                <IconButton
                                                    onClick={handleClick}
                                                >
                                                    <Badge
                                                        badgeContent={
                                                            filteredSelectedIndustryType?.length +
                                                            filteredSelectedStatus?.length +
                                                            filteredSelectedKeyAccount?.length +
                                                            filteredSelectedLocation?.length +
                                                            filteredSelectedTurnOver?.length +
                                                            filteredSelectedTotalCorfqValue?.length +
                                                            filteredSelectedTotalCoPoValue?.length
                                                        }
                                                        color="primary"
                                                    >
                                                        <FilterAltOutlinedIcon />
                                                    </Badge>
                                                </IconButton>
                                                <Popper
                                                    open={Boolean(anchorEl)}
                                                    anchorEl={anchorEl}
                                                    placement="bottom-start"
                                                    sx={{ zIndex: 13 }}
                                                >
                                                    <Paper
                                                        ref={popperRef}
                                                        sx={{
                                                            p: 2,
                                                            width: 350,
                                                            boxShadow: 3,
                                                            borderRadius: 2
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                fontWeight:
                                                                    "bold",
                                                                mb: 2,
                                                                display: "flex",
                                                                justifyContent:
                                                                    "space-between"
                                                            }}
                                                        >
                                                            Filter{" "}
                                                            <Button
                                                                size="small"
                                                                variant="outlined"
                                                                onClick={
                                                                    handleClearAll
                                                                }
                                                            >
                                                                CLEAR ALL
                                                            </Button>
                                                        </Box>

                                                        <Box sx={{ mb: 2 }}>
                                                            <Autocomplete
                                                                multiple
                                                                size="small"
                                                                sx={{
                                                                    marginBottom:
                                                                        "15px"
                                                                }}
                                                                limitTags={2}
                                                                id="multiple-limit-tags"
                                                                getOptionLabel={(
                                                                    option
                                                                ) =>
                                                                    option?.title ||
                                                                    ""
                                                                }
                                                                value={
                                                                    selectedLocation
                                                                }
                                                                onChange={(
                                                                    event,
                                                                    newValue
                                                                ) =>
                                                                    setSelectedLocation(
                                                                        newValue ||
                                                                            []
                                                                    )
                                                                }
                                                                isOptionEqualToValue={(
                                                                    option,
                                                                    value
                                                                ) =>
                                                                    option.title ===
                                                                    value?.title
                                                                }
                                                                options={[
                                                                    ...(filterOptions?.locationTypeOptions ||
                                                                        [])
                                                                ]?.sort(
                                                                    (a, b) =>
                                                                        a?.title?.localeCompare(
                                                                            b?.title
                                                                        )
                                                                )}
                                                                renderInput={(
                                                                    params
                                                                ) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Presence"
                                                                        placeholder="Select Presence"
                                                                    />
                                                                )}
                                                            />
                                                            {(accountManagerHead() ||
                                                                isManagement()) && (
                                                                <Autocomplete
                                                                    multiple
                                                                    size="small"
                                                                    sx={{
                                                                        marginBottom:
                                                                            "15px"
                                                                    }}
                                                                    limitTags={
                                                                        2
                                                                    }
                                                                    id="multiple-limit-tags"
                                                                    options={[
                                                                        ...(filterOptions?.keyAccountManagerOptions ||
                                                                            [])
                                                                    ]?.sort(
                                                                        (
                                                                            a,
                                                                            b
                                                                        ) =>
                                                                            a.title.localeCompare(
                                                                                b.title
                                                                            )
                                                                    )}
                                                                    getOptionLabel={(
                                                                        option
                                                                    ) =>
                                                                        option?.title ||
                                                                        ""
                                                                    }
                                                                    value={
                                                                        selectedKeyAccount
                                                                    }
                                                                    onChange={(
                                                                        event,
                                                                        newValue
                                                                    ) =>
                                                                        setSelectedKeyAccount(
                                                                            newValue ||
                                                                                []
                                                                        )
                                                                    }
                                                                    isOptionEqualToValue={(
                                                                        option,
                                                                        value
                                                                    ) =>
                                                                        option.title ===
                                                                        value?.title
                                                                    }
                                                                    renderInput={(
                                                                        params
                                                                    ) => (
                                                                        <TextField
                                                                            {...params}
                                                                            label="Key Account Manager"
                                                                            placeholder="Select Key Account Manager"
                                                                        />
                                                                    )}
                                                                />
                                                            )}

                                                            <Autocomplete
                                                                multiple
                                                                size="small"
                                                                sx={{
                                                                    marginBottom:
                                                                        "15px"
                                                                }}
                                                                limitTags={2}
                                                                id="multiple-limit-tags"
                                                                options={[
                                                                    ...(filterOptions?.industryTypeOptions ||
                                                                        [])
                                                                ]?.sort(
                                                                    (a, b) =>
                                                                        a?.title?.localeCompare(
                                                                            b?.title
                                                                        )
                                                                )}
                                                                getOptionLabel={(
                                                                    option
                                                                ) =>
                                                                    option?.title ||
                                                                    ""
                                                                }
                                                                value={
                                                                    selectedIndustryType
                                                                }
                                                                onChange={(
                                                                    event,
                                                                    newValue
                                                                ) =>
                                                                    setSelectedIndustryType(
                                                                        newValue ||
                                                                            []
                                                                    )
                                                                }
                                                                isOptionEqualToValue={(
                                                                    option,
                                                                    value
                                                                ) =>
                                                                    option.title ===
                                                                    value?.title
                                                                }
                                                                renderInput={(
                                                                    params
                                                                ) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Industry Type"
                                                                        placeholder="Select Industry"
                                                                    />
                                                                )}
                                                            />

                                                            <Autocomplete
                                                                multiple
                                                                size="small"
                                                                sx={{
                                                                    marginBottom:
                                                                        "15px"
                                                                }}
                                                                limitTags={2}
                                                                id="totalCorfqValue"
                                                                options={[
                                                                    ...(filterOptions?.totalCorfqValueOptions ||
                                                                        [])
                                                                ]}
                                                                getOptionLabel={(
                                                                    option
                                                                ) =>
                                                                    option?.key ||
                                                                    ""
                                                                }
                                                                value={
                                                                    selectedTotalCorfqValue
                                                                }
                                                                onChange={(
                                                                    event,
                                                                    newValue
                                                                ) =>
                                                                    setSelectedTotalCorfqValue(
                                                                        newValue ||
                                                                            []
                                                                    )
                                                                }
                                                                renderInput={(
                                                                    params
                                                                ) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Total CORFQ Value"
                                                                        placeholder="Select Total CORFQ Value"
                                                                    />
                                                                )}
                                                            />

                                                            <Autocomplete
                                                                multiple
                                                                size="small"
                                                                sx={{
                                                                    marginBottom:
                                                                        "15px"
                                                                }}
                                                                limitTags={2}
                                                                id="totalCoPoValue"
                                                                options={[
                                                                    ...(filterOptions?.totalCoPoValueOptions ||
                                                                        [])
                                                                ]}
                                                                getOptionLabel={(
                                                                    option
                                                                ) =>
                                                                    option?.key ||
                                                                    ""
                                                                }
                                                                value={
                                                                    selectedTotalCoPoValue
                                                                }
                                                                onChange={(
                                                                    event,
                                                                    newValue
                                                                ) =>
                                                                    setSelectedTotalCoPoValue(
                                                                        newValue ||
                                                                            []
                                                                    )
                                                                }
                                                                renderInput={(
                                                                    params
                                                                ) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Total COPO Value"
                                                                        placeholder="Select Total COPO Value"
                                                                    />
                                                                )}
                                                            />
                                                        </Box>

                                                        {/* Apply / Cancel Buttons */}
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                justifyContent:
                                                                    "space-between",
                                                                mt: 2
                                                            }}
                                                        >
                                                            <Button
                                                                onClick={
                                                                    handleClose
                                                                }
                                                                color="error"
                                                            >
                                                                CANCEL
                                                            </Button>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={
                                                                    handleApply
                                                                }
                                                            >
                                                                APPLY
                                                            </Button>
                                                        </Box>
                                                    </Paper>
                                                </Popper>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                        <Grid size={{ xs: 12, md: 12 }}>
                            {/* Selected Filters as Chips */}
                            {isApplyFilter == true && (
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: 1,
                                        marginBottom: "10px"
                                    }}
                                >
                                    {filteredSelectedLocation?.map(
                                        (item, index) => (
                                            <Chip
                                                key={`location-${index}`}
                                                label={item?.title}
                                                onDelete={() =>
                                                    handleRemoveFilter(
                                                        "location",
                                                        item
                                                    )
                                                }
                                                size="small"
                                            />
                                        )
                                    )}

                                    {filteredSelectedKeyAccount?.map(
                                        (item, index) => (
                                            <Chip
                                                key={`keyAccountManager-${index}`}
                                                label={item?.title}
                                                onDelete={() =>
                                                    handleRemoveFilter(
                                                        "keyAccountManager",
                                                        item
                                                    )
                                                }
                                                size="small"
                                            />
                                        )
                                    )}
                                    {filteredSelectedIndustryType?.map(
                                        (item, index) => (
                                            <Chip
                                                key={`industry-${index}`}
                                                label={item?.title}
                                                onDelete={() =>
                                                    handleRemoveFilter(
                                                        "industry",
                                                        item
                                                    )
                                                }
                                                size="small"
                                            />
                                        )
                                    )}

                                    {filteredSelectedTotalCorfqValue?.map(
                                        (item, index) => (
                                            <Chip
                                                key={`totalCorfqValue-${index}`}
                                                label={item?.key}
                                                onDelete={() =>
                                                    handleRemoveFilter(
                                                        "totalCorfqValue",
                                                        item
                                                    )
                                                }
                                                size="small"
                                            />
                                        )
                                    )}

                                    {filteredSelectedTotalCoPoValue?.map(
                                        (item, index) => (
                                            <Chip
                                                key={`totalCoPoValue-${index}`}
                                                label={item?.key}
                                                onDelete={() =>
                                                    handleRemoveFilter(
                                                        "totalCoPoValue",
                                                        item
                                                    )
                                                }
                                                size="small"
                                            />
                                        )
                                    )}

                                    {/* Clear All Button - Show only when filters exist */}
                                    {filteredSelectedLocation?.length +
                                        filteredSelectedKeyAccount?.length +
                                        filteredSelectedStatus?.length +
                                        filteredSelectedTotalCorfqValue?.length +
                                        filteredSelectedTotalCoPoValue.length +
                                        filteredSelectedTurnOver?.length >
                                        0 && (
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            onClick={handleClearAllChip}
                                            sx={{
                                                fontSize: ".75rem !important",
                                                lineHeight: "1",
                                                borderRadius: "30px"
                                            }}
                                        >
                                            CLEAR ALL
                                        </Button>
                                    )}
                                </Box>
                            )}
                        </Grid>
                        <Paper
                            sx={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height:
                                    companyRows?.length > 4
                                        ? "61vh"
                                        : companyRows?.length < 4
                                          ? "auto"
                                          : "61vh"
                            }}
                        >
                            {!isLoading ? (
                                companyRows?.length > 0 ? (
                                    <DataGridPro
                                        rows={companyRows}
                                        pinnedColumns={pinnedColumns}
                                        getRowHeight={() => "auto"}
                                        onPinnedColumnsChange={
                                            handlePinnedColumnsChange
                                        }
                                        columns={columnsCompany}
                                        pagination={filteredRows?.length > 10}
                                        paginationModel={paginationModel}
                                        onPaginationModelChange={
                                            setPaginationModel
                                        }
                                        pageSizeOptions={[10, 20]}
                                        rowSelectionModel={selectedRows}
                                        onRowSelectionModelChange={
                                            handleSelectionChange
                                        }
                                        sx={{
                                            width: "100%",
                                            "& .MuiDataGrid-columnHeaderTitleContainer":
                                                {
                                                    "& .MuiDataGrid-sortIcon": {
                                                        opacity: "1 !important",
                                                        visibility:
                                                            "visible !important"
                                                    }
                                                },
                                            "& .MuiDataGrid-cell": {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            "& .MuiDataGrid-scrollbarFiller--pinnedRight":
                                                {
                                                    backgroundColor:
                                                        "#F4F4F4!important"
                                                }
                                        }}
                                    />
                                ) : (
                                    <>
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                gap: "8px",
                                                padding: "20px"
                                            }}
                                        >
                                            {(searchTerm &&
                                                companyRows?.length == 0) ||
                                            (isApplyFilter &&
                                                companyRows?.length == 0) ? (
                                                "No Options available"
                                            ) : (
                                                <>
                                                    <img
                                                        src={emptyImage}
                                                        alt="Empty"
                                                        width={"300px"}
                                                    />
                                                    <b
                                                        style={{
                                                            color: "#0009"
                                                        }}
                                                    >
                                                        {partnerMessages[
                                                            value
                                                        ] || "Unknown Status"}
                                                    </b>
                                                </>
                                            )}
                                        </div>
                                    </>
                                )
                            ) : (
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="50vh"
                                >
                                    <ThreeDot
                                        color="#1976d2"
                                        size="medium"
                                        text=""
                                        textColor=""
                                    />
                                </Box>
                            )}
                        </Paper>
                    </StyledTabPanel>

                    {/* Associated Company Drawer */}
                    <AssociatedCompanyDrawer
                        open={openDrawer}
                        onClose={handleCloseDrawer}
                        selectedPartner={selectedRow}
                    />

                    {/* Associated RFQ Drawer */}
                    <AssociatedRFQsDrawer
                        open={openDrawerAsRfq}
                        onClose={handleCloseDrawerAsRfq}
                        selectedPartner={selectedRow}
                        value={value}
                    />

                    {/* Associated RFQ Drawer */}
                    <CompanyProfileDrawer
                        open={openDrawerAsCompany}
                        onClose={handleCloseDrawerAsCompany}
                        selectedPartner={selectedRow}
                        tableData={rows}
                    />
                </TabContext>
            </Box>
        </>
    );
};
